import React from 'react';

import './style.sass';
import FullWrapper from '../../cases/reusable-components/layouts-components__common-cases/full-wrapper';

const Task = ({ listTask }) => {
    return (
        <div className="case-task">
            <FullWrapper>
                <div className="case-task__wrapper">
                    <div className="case-task__title">Задачи</div>
                    <div className="case-task__items">
                        {listTask.map((item, index) => (
                            <div className="case-task__item" key={index}>
                                <div className="case-task__number">{item.number}</div>
                                <div className="case-task__text">{item.text}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Task;
